// @material-ui/core
import {
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@material-ui/core";
// @material-ui/core/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import {
  AccountCircle as AccountIcon,
  Apps as AppsIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  Class as ClassIcon,
  Dashboard as DashboardIcon,
  HelpOutline as HelpIcon,
  InfoOutline as InfoIcon,
  People as PeopleIcon
} from "@material-ui/icons";
// import Caba from "../services/Caba";
// import gTemplate from "../services/gTemplate";
// theme
import classNames from "classnames";
import ChevronDoubleLeftIcon from "mdi-react/ChevronDoubleLeftIcon";
import ChevronDoubleRightIcon from "mdi-react/ChevronDoubleRightIcon";
import PropTypes from "prop-types";
import React, { Component } from "react";
// router
import { NavLink } from "react-router-dom";
// custom
import LogoLoader from "./LogoLoader";

// constants
const drawerWidth = 240;
const styles = theme => ({
  drawerPaper: {
    position: "relative",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: 0,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9
    }
  },
  drawerInner: {
    // Make the items inside not wrap when transitioning:
    width: drawerWidth,
    height: "100%"
  },
  fullHeight: {
    height: "100%"
  },
  drawerLogo: {
    float: "left"
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar
  },
  flex: {
    flex: "1"
  },
  center: {
    textAlign: "center"
  },
  icon: {
    color: "rgba(0, 0, 0, 0.54)",
    "& path": {
      fill: "rgba(0, 0, 0, 0.54)"
    }
  },
  item: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column"
  },
  itemNoGrow: {
    flex: "0 1 auto",
    display: "flex",
    flexDirection: "column"
  },
  hide: {
    display: "none"
  }
});

class MainMenu extends Component {
  state = {
    open: this.props.open,
    isAutoClose: this.props.autoClose,
    basicMenu: [
      {
        title: "Profile",
        icon: AccountIcon,
        to: "/profile"
      },
      {
        title: "About",
        icon: InfoIcon,
        to: "/about"
      },
      {
        title: "Support",
        icon: HelpIcon,
        to: "/support"
      }
    ],
    menu: [
      {
        id: "apps",
        title: "Apps",
        icon: AppsIcon,
        to: "/apps"
      },
      {
        id: "customers",
        title: "Customers",
        icon: PeopleIcon,
        to: "/customers"
      },
      {
        id: "licenses",
        title: "Licenses",
        icon: ClassIcon,
        to: "/licenses"
      }
    ],
    scopes: { apps: true, customers: true, licenses: true }
  };

  toggleOpen(open) {
    if (open && !this.props.open && this.props.isAutoClose) {
      this.props.handleToggle();
    } else if (!open && this.props.open && this.props.isAutoClose) {
      this.props.handleToggle();
    }
  }

  render() {
    const { classes, theme } = this.props;

    let expandText = "Collapse sidebar";
    if (this.props.isAutoClose) {
      expandText = "Static sidebar";
    }

    const basicMenuItems = this.state.basicMenu.map((item, index) => {
      return (
        <NavLink to={item.to} activeClassName="active" key={index}>
          <ListItem button onClick={this.props.handleClose}>
            <ListItemIcon>
              <item.icon />
            </ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        </NavLink>
      );
    });
    const mappedMenu = this.state.menu.filter(item => {
      return this.state.scopes[item.id];
    });
    const menuItems = mappedMenu.map(item => {
      return (
        <NavLink
          to={item.to}
          activeClassName="active"
          exact={item.exact}
          key={item.id}>
          <ListItem button onClick={this.props.handleClose}>
            <ListItemIcon>
              <item.icon />
            </ListItemIcon>
            <ListItemText primary={item.title} />
          </ListItem>
        </NavLink>
      );
    });

    return (
      <Drawer
        variant="permanent"
        classes={{
          paper: classNames(
            classes.drawerPaper,
            !this.props.open && classes.drawerPaperClose
          )
        }}
        open={this.props.open}
        onMouseEnter={() => this.toggleOpen(true)}
        onMouseLeave={() => this.toggleOpen(false)}>
        <div className={classes.drawerInner}>
          <Grid
            container
            direction={"column"}
            justify={"space-between"}
            // classes={{
            // typeContainer: classes.fullHeight
            // }}
          >
            <Grid item xs={12}>
              <div className={classes.drawerHeader}>
                <Grid container justify="center" alignItems="center">
                  <Grid item xs={this.props.open ? 3 : 12}>
                    <LogoLoader
                      fill="rgba(0, 0, 0, 0.54)"
                      loading={this.props.isLoading}
                    />
                  </Grid>
                  {this.props.open && (
                    <Grid item xs={6}>
                      <Typography
                        className={classNames(classes.flex, classes.center)}
                        type="caption"
                        color="inherit"
                        noWrap>
                        CLOUDPILOTS<br />
                        <small>
                          <strong>Caba</strong>
                        </small>
                      </Typography>
                    </Grid>
                  )}
                  {this.props.open && (
                    <Grid item xs={3}>
                      <IconButton
                        onClick={this.props.handleAutoClose}
                        className={classNames(
                          this.props.isAutoClose && classes.hide
                        )}>
                        {theme.direction === "rtl" ? (
                          <ChevronRightIcon />
                        ) : (
                          <ChevronLeftIcon />
                        )}
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </div>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <List>
                <NavLink to="/" activeClassName="active" exact>
                  <ListItem button onClick={this.props.handleClose}>
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                  </ListItem>
                </NavLink>
                {menuItems}
              </List>
            </Grid>

            <Grid item xs={12}>
              <Divider />
              <List>{basicMenuItems}</List>
            </Grid>

            <Grid item xs={12}>
              <Divider />
              <List>
                <ListItem button onClick={this.props.handleAutoClose}>
                  <ListItemIcon>
                    {!this.props.open || this.props.isAutoClose ? (
                      <ChevronDoubleRightIcon className={classes.icon} />
                    ) : (
                      <ChevronDoubleLeftIcon className={classes.icon} />
                    )}
                  </ListItemIcon>
                  <ListItemText primary={expandText} />
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    );
  }
}

MainMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(MainMenu);



// WEBPACK FOOTER //
// ./src/appBar/MainMenu.js